enum EppoFlags {
  DriverWebFederation = 'Delivery::DriverWebFederation',
}

export default EppoFlags;
